import { createSlice } from "@reduxjs/toolkit";
import {
  GetAllPaymentData,
  PaymentInitialStatus,
} from "../../../../types/redux";
import {
  bulkCreatePriceMatrixAsync,
  getAllPaymentAsync,
  getAllPriceMatrixAsync,
  getAllPriceMatrixLogsAsync,
  getCountPaymentAsync,
  getFinanceBalanceAsync,
  getSinglePriceMatrixAsync,
  getTotalAmountAsync,
  updatePriceMatrixAsync,
  updateStatusAsync,
} from "./paymentAPI";

const initialState: PaymentInitialStatus<GetAllPaymentData> = {
  loading: false,
  postLoading: false,
  deleteLoading: false,
  updateLoading: false,
  allPayment: [],
  allPriceMatrix: [],
  allPriceMatrixLogs: [],
  totalAmount: { sustus: "", data: { totalAmount: 0 } },
  paymentCount: 0,
  financeBalance: 0,
  allPriceMatrixTotal: 0,
  allPriceMatrixTotalLogs: 0,
  singlePriceMatrix: null,
  singlePriceMatrixLoading: false,
};

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get all Payment
    builder
      .addCase(getAllPaymentAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllPaymentAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.allPayment = action.payload;
      })
      .addCase(getAllPaymentAsync.rejected, (state) => {
        state.loading = false;
        state.allPayment = [];
      });
    // get payment count
    builder
      .addCase(getCountPaymentAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCountPaymentAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentCount = action.payload;
      })
      .addCase(getCountPaymentAsync.rejected, (state) => {
        state.loading = false;
        state.paymentCount = 0;
      });

    // tower all amount
    builder
      .addCase(getTotalAmountAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTotalAmountAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.totalAmount = action.payload;
      })
      .addCase(getTotalAmountAsync.rejected, (state) => {
        state.loading = false;
        state.totalAmount = { sustus: "", data: { totalAmount: 0 } };
      });
    builder
      .addCase(updateStatusAsync.pending, (state) => {
        state.updateLoading = true;
      })
      .addCase(updateStatusAsync.fulfilled, (state, action) => {
        state.updateLoading = false;
      })
      .addCase(updateStatusAsync.rejected, (state) => {
        state.updateLoading = false;
      });

    // Get Finance Balance
    builder
      .addCase(getFinanceBalanceAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFinanceBalanceAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.financeBalance = action.payload;
      })
      .addCase(getFinanceBalanceAsync.rejected, (state) => {
        state.loading = false;
        state.financeBalance = 0;
      });

    // create price matrix
    builder
      .addCase(bulkCreatePriceMatrixAsync.pending, (state) => {
        state.postLoading = true;
      })
      .addCase(bulkCreatePriceMatrixAsync.fulfilled, (state) => {
        state.postLoading = false;
      })
      .addCase(bulkCreatePriceMatrixAsync.rejected, (state) => {
        state.postLoading = false;
      });

    // Get all price matrix
    builder
      .addCase(getAllPriceMatrixAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllPriceMatrixAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.allPriceMatrix = action.payload.data ?? [];
        state.allPriceMatrixTotal = action.payload.total;
      })
      .addCase(getAllPriceMatrixAsync.rejected, (state) => {
        state.loading = false;
        state.allPriceMatrix = [];
        state.allPriceMatrixTotal = 0;
      });

    //  Get Single Price Matrix
    builder
      .addCase(getSinglePriceMatrixAsync.pending, (state) => {
        state.singlePriceMatrixLoading = true;
      })
      .addCase(getSinglePriceMatrixAsync.fulfilled, (state, action) => {
        state.singlePriceMatrixLoading = false;
        state.singlePriceMatrix = action.payload;
      })
      .addCase(getSinglePriceMatrixAsync.rejected, (state) => {
        state.singlePriceMatrixLoading = false;
        state.singlePriceMatrix = null;
      });

    // Price matrix updated
    builder
      .addCase(updatePriceMatrixAsync.pending, (state) => {
        state.updateLoading = true;
      })
      .addCase(updatePriceMatrixAsync.fulfilled, (state) => {
        state.updateLoading = false;
      })
      .addCase(updatePriceMatrixAsync.rejected, (state) => {
        state.updateLoading = false;
      });

    // Get all price matrix logs
    builder
      .addCase(getAllPriceMatrixLogsAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllPriceMatrixLogsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.allPriceMatrixLogs = action.payload.data ?? [];
        state.allPriceMatrixTotalLogs = action.payload.total;
      })
      .addCase(getAllPriceMatrixLogsAsync.rejected, (state) => {
        state.loading = false;
        state.allPriceMatrixLogs = [];
        state.allPriceMatrixTotalLogs = 0;
      });
  },
});

export default paymentSlice;
